import { DateTime } from "luxon";

/**
 * Given a date and a format, return the formatted date.
 */
export function formatDate({
  date,
  format,
}: {
  date: DateTime;
  format: "Jan 1, 2025" | "Wed, Jan 1 at 3:30 pm" | "Wed, Jan 1" | "Wed, Jan 1, 2025";
}) {
  switch (format) {
    case "Jan 1, 2025":
      return date.toFormat("MMM d, yyyy");
    case "Wed, Jan 1":
      return date.toFormat("ccc, MMM d");
    case "Wed, Jan 1, 2025":
      return date.toFormat("ccc, MMM, d, yyyy");
    case "Wed, Jan 1 at 3:30 pm":
      return `${date.toFormat("ccc, MMM d")} at ${date.toFormat("h:mm a").toLowerCase()}`;
    default:
      throw new Error(`Unsupported format: ${format}`);
  }
}

/**
 * Given a date and a format, return the formatted time.
 */
export function formatTime({ date, format }: { date: DateTime; format: "1:00 pm" }) {
  switch (format) {
    case "1:00 pm":
      return date.toFormat("h:mm a").toLowerCase();
    default:
      throw new Error(`Unsupported format: ${format}`);
  }
}
